import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LeftArw } from '../../assests/ExportImageIcon';
import service from '../../services/service';
import endpoints from '../../services/endpoints';

const UserDetail = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const userId = state?.userId;
  const [activeTab, setActiveTab] = useState('userDetails');
  const [loading, setLoading] = useState(true);
  const [sendingLink, setSendingLink] = useState(false);
  const [showResendSuccess, setShowResendSuccess] = useState(false);
  const [brokerEmail, setBrokerEmail] = useState('');
  const [sendingBrokerMail, setSendingBrokerMail] = useState(false);
  const [sendingBrokerMailSuccess, setSendingBrokerMailSuccess] =
    useState(false);
  const [brokerEmailHint, setBrokerEmailHint] = useState(null);
  const [user, setUser] = useState(null);
  const [downloadingPdf, setDownloadingPdf] = useState(false);

  useEffect(() => {
    const fetchDetail = async () => {
      if (!userId) {
        setLoading(false);
        return;
      }
      try {
        const url = endpoints.admin.userDetail.replace('{user_id}', userId);
        const res = await service.get(url);
        setUser(res.data?.data || null);
      } catch (err) {
        console.error('Failed to fetch user detail:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchDetail();
  }, [userId]);

  const handleResendEmail = async () => {
    if (!userId) return;
    setSendingLink(true);
    try {
      const url = endpoints.admin.sendlink.replace('{user_id}', userId);
      await service.post(url, {});
      setShowResendSuccess(true);
      setTimeout(() => setShowResendSuccess(false), 2500);
    } catch (err) {
      console.error('Failed to send link:', err);
    } finally {
      setSendingLink(false);
    }
  };

  const handleSendBrokerMail = async () => {
    if (!userId) return;
    const email = brokerEmail.trim();
    if (!email) {
      setBrokerEmailHint('Please enter a broker email address.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setBrokerEmailHint('Please enter a valid email address.');
      return;
    }
    setBrokerEmailHint(null);
    setSendingBrokerMail(true);
    try {
      await service.post(endpoints.admin.sendMailBroker, {
        user_id: userId,
        email: email,
      });
      setSendingBrokerMailSuccess(true);
      setTimeout(() => {
        setSendingBrokerMailSuccess(false);
        setBrokerEmail('');
        setBrokerEmailHint(null);
      }, 2000);
    } catch (err) {
      console.error('Failed to send broker mail:', err);
      setSendingBrokerMailSuccess(false);
    } finally {
      setSendingBrokerMail(false);
    }
  };

  const handleDownloadPdf = async () => {
    if (!userId) return;
    setDownloadingPdf(true);
    try {
      const url = endpoints.admin.downloadPdf.replace('{user_id}', userId);
      const res = await service.download(url);
      const blob = new Blob([res.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `user-${userId}.pdf`;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (err) {
      console.error('Failed to download PDF:', err);
    } finally {
      setDownloadingPdf(false);
    }
  };

  const val = (v) => v || '-';

  return (
    <div>
      {showResendSuccess && (
        <div className="confirm-overlay">
          <div className="confirm-modal">
            <div className="success-icon">✓</div>
            <h3>Email Resent!</h3>
            <p>Chat link has been sent successfully.</p>
          </div>
        </div>
      )}
      {sendingBrokerMailSuccess && (
        <div className="success-overlay">
          <div className="success-modal">
            <div className="success-icon">✓</div>
            <h3>Email Sent Successfully!</h3>
            <p>Email has been sent to {brokerEmail}</p>
          </div>
        </div>
      )}
      <div className="commonBorder commonRadius-12 bg-white">
        <div className="topPart">
          <div className="d-flex gap-3 align-items-center">
            <div className="btnAction" onClick={() => navigate('/dashboard')}>
              <img src={LeftArw} />
            </div>
            <div className="heading">User Detail</div>
          </div>
          <div className="rightSide">
          <div className='d-flex gap-3'>
            <button className="pdfDownload" onClick={handleDownloadPdf} disabled={downloadingPdf}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="pdf-icon">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/>
                <path d="M14 2v6h6"/>
                <path d="M9 13h6M9 17h3" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
              </svg>
              {downloadingPdf ? 'Downloading...' : 'Download PDF'}
            </button>
            <button
              className="commonOrngBtn"
              onClick={handleResendEmail}
              disabled={sendingLink}
            >
              {sendingLink ? 'Sending...' : 'Re-Send Email'}
            </button>
          </div>
            
          </div>
        </div>
      </div>
      <div className="formArea mt-3 commonBorder commonRadius-12 bg-white">
        <div className="tabbing">
          <div
            className={`tab ${activeTab === 'userDetails' ? 'active' : ''}`}
            onClick={() => setActiveTab('userDetails')}
          >
            User Details
          </div>
          <div
            className={`tab ${activeTab === 'chatSummary' ? 'active' : ''}`}
            onClick={() => setActiveTab('chatSummary')}
          >
            Chat Summary
          </div>
        </div>

        {activeTab === 'chatSummary' && (
          <div className="row g-4">
            <div className="col-md-12">
              <div className="formhead">Share with Broker / Contractor</div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Broker Email ID</label>
                <div className="d-flex gap-3">
                  <input
                    type="email"
                    autoComplete="email"
                    placeholder="broker@example.com"
                    className="w-100"
                    value={brokerEmail}
                    onChange={(e) => {
                      setBrokerEmail(e.target.value);
                      if (brokerEmailHint) setBrokerEmailHint(null);
                    }}
                    disabled={sendingBrokerMail}
                  />
                  <button
                    type="button"
                    className="commonOrngBtn"
                    onClick={handleSendBrokerMail}
                    disabled={sendingBrokerMail || !userId}
                  >
                    {sendingBrokerMail ? 'Sending…' : 'Send'}
                  </button>
                </div>
                {brokerEmailHint && (
                  <p className="mt-2 mb-0 small" style={{ color: '#b91c1c' }}>
                    {brokerEmailHint}
                  </p>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="formhead">Chat Summary</div>
            </div>
            <div className="col-md-12">
              <div className="chatHistory">
                <div className="chatAll">
                  {user?.chats?.map((chat, index) => (
                    <div
                      key={index}
                      className={`chat${chat.role === 'user' ? 'Sender' : 'Receiver'} chatCommon`}
                    >
                      {chat.text}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'userDetails' &&
          (loading ? (
            <div style={{ textAlign: 'center', padding: '30px' }}>
              Loading...
            </div>
          ) : (
            <div className="row g-4">
              <div className="col-md-12">
                <div className="formhead">Basic Details</div>
              </div>
              {/* <div className='col-md-4'>
                                <div className='form-group'>
                                    <label>Name</label>
                                    <p>{val(user?.name)}</p>
                                </div>
                            </div> */}
              <div className="col-md-4">
                <div className="form-group">
                  <label>Customer Name</label>
                  <p>{val(user?.customerName)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Email ID</label>
                  <p>{val(user?.email)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Phone Number</label>
                  <p>{val(user?.phoneNumber)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Communication Preference</label>
                  <p>{val(user?.communicationPreference)}</p>
                </div>
              </div>
              <div className="col-md-12 mt-5">
                <div className="formhead">Property & Budget Requirements</div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Property Type</label>
                  <p>{val(user?.propertyType)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Monthly Budget</label>
                  <p>{val(user?.monthlyBudget)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Bedroom Count</label>
                  <p>{val(user?.bedroomCount)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Bathroom Count</label>
                  <p>{val(user?.bathroomCount)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Lease Start Date</label>
                  <p>{val(user?.leaseStartDate)}</p>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label>Ideal Home Description</label>
                  <p>{val(user?.idealHomeDescription)}</p>
                </div>
              </div>
              <div className="col-md-12 mt-5">
                <div className="formhead">Location Preferences</div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Neighborhood Preferences</label>
                  <p>{val(user?.neighborhoodPreferences)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Area Preference</label>
                  <p>{val(user?.areaPreference)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Specific Neighborhoods</label>
                  <p>{val(user?.specificNeighborhoods)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Commute Time</label>
                  <p>{val(user?.commuteTime)}</p>
                </div>
              </div>
              <div className="col-md-12 mt-5">
                <div className="formhead">Lifestyle & Specific Needs</div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Must Have Features</label>
                  <p>{val(user?.mustHaveFeatures)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Deal Breakers</label>
                  <p>{val(user?.dealBreakers)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Identified Properties</label>
                  <p>{val(user?.identifiedProperties)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Family Needs</label>
                  <p>{val(user?.familyNeeds)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Pet Type</label>
                  <p>{val(user?.petType)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Pet Details</label>
                  <p>{val(user?.petDetails)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Hobbies Interests</label>
                  <p>{val(user?.hobbiesInterests)}</p>
                </div>
              </div>
              <div className="col-md-12 mt-5">
                <div className="formhead">Relocation & Support Services</div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Settling Priorities</label>
                  <p>{val(user?.settlingPriorities)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Top Priorities</label>
                  <p>{val(user?.topPriorities)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Documentation Assistance</label>
                  <p>{val(user?.documentationAssistance)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Community Introductions</label>
                  <p>{val(user?.communityIntroductions)}</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Settled Quickly Support</label>
                  <p>{val(user?.settledQuicklySupport)}</p>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <label>Additional Notes</label>
                  <p>{val(user?.additionalNotes)}</p>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default UserDetail;
